import axios from 'axios'

export const getAllCategories = (params) => {
  let remoteUrl = 'categories'

  return axios.get(remoteUrl, {params: params})
}

export const getCategory = (id, params) => {
  let remoteUrl = 'categories/' + id

  return axios.get(remoteUrl, {params: params})
}

export const addCategory = (data) => {
  let remoteUrl = 'categories'
  return axios.post(remoteUrl, data)
}

export const editCategory = (id, data) => {
  let remoteUrl = 'categories/' + id
  return axios.put(remoteUrl, data)
}

export const deleteCategory = (id) => {
  let remoteUrl = 'categories/' + id
  return axios.delete(remoteUrl)
}

export const getCategoryHelpers = () => {
  return axios.get('helpers/categories')
}

export const getToTreeCategory = (params) => {
  return axios.get('categories/get/to-tree', {params: params})
}



// WEBPACK FOOTER //
// ./src/api/categories.js